import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ViewByType } from 'container/ManageOrders'

type InitialState = {
  viewByFilter: ViewByType
  orderStep: 0 | 1
  isDirty: boolean
  showPrompt: boolean
  confirmedNavigation: boolean
  globalLoading: boolean
  tabBlockers: string[]
  focusMaterialInsertInput: boolean
  ovInitialTab: number
  salesOrderInitialTab: number
  salesOrderCurrentTab: number
  showDetailedStock: boolean
  loginValidation: boolean
}
const initialState: InitialState = {
  viewByFilter: 'orders',
  orderStep: 0,
  isDirty: false,
  showPrompt: false,
  confirmedNavigation: false,
  globalLoading: false,
  tabBlockers: [],
  focusMaterialInsertInput: false,
  ovInitialTab: 0,
  salesOrderInitialTab: -1,
  salesOrderCurrentTab: -1,
  showDetailedStock: true,
  loginValidation: false
}

export const structure = createSlice({
  name: 'structure',
  initialState,
  reducers: {
    setViewByFilter: (state, action: PayloadAction<ViewByType>) => {
      state.viewByFilter = action.payload
    },
    updateOrderStep(state, action: PayloadAction<0 | 1>) {
      state.orderStep = action.payload
    },
    setDirty: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload
    },
    setShowPrompt: (state, action: PayloadAction<boolean>) => {
      state.showPrompt = action.payload
    },
    setConfirmedNavigation: (state, action: PayloadAction<boolean>) => {
      state.confirmedNavigation = action.payload
    },
    setGlobalLoading(state, action: PayloadAction<boolean>) {
      state.globalLoading = action.payload
    },
    addTabBlocker(state, action: PayloadAction<string>) {
      if (!state.tabBlockers.includes(action.payload)) {
        state.tabBlockers.push(action.payload)
      }
    },
    removeTabBlocker(state, action: PayloadAction<string>) {
      state.tabBlockers = state.tabBlockers.filter(
        (blocker) => blocker !== action.payload
      )
    },
    clearTabBlockers(state) {
      state.tabBlockers = []
    },
    setFocusMaterialInsertInput(state, action: PayloadAction<boolean>) {
      state.focusMaterialInsertInput = action.payload
    },
    setOvInitialTab(state, action: PayloadAction<number>) {
      state.ovInitialTab = action.payload
    },
    setSalesOrderInitialTab(state, action: PayloadAction<number>) {
      state.salesOrderInitialTab = action.payload
    },
    setSalesOrderCurrentTab(state, action: PayloadAction<number>) {
      state.salesOrderCurrentTab = action.payload
    },
    setShowDetailedStock(state, action: PayloadAction<boolean>) {
      state.showDetailedStock = action.payload
    },
    setLoginValidation(state, action: PayloadAction<boolean>) {
      state.loginValidation = action.payload
    }
  }
})
export const structuralContext = structure.reducer
export const {
  setViewByFilter,
  updateOrderStep,
  setDirty,
  setConfirmedNavigation,
  setShowPrompt,
  setGlobalLoading,
  addTabBlocker,
  removeTabBlocker,
  clearTabBlockers,
  setFocusMaterialInsertInput,
  setOvInitialTab,
  setSalesOrderInitialTab,
  setSalesOrderCurrentTab,
  setShowDetailedStock,
  setLoginValidation
} = structure.actions
